import Vue from 'vue'
import App from './App.vue'
import store from './store'
import LocalStorageWatcher from "./plugin/localStorageWatcher"
import markdownFilter from './filters/markdown'

import './styles/global-styles.css'

import 'document-register-element/build/document-register-element';
import vueCustomElement from 'vue-custom-element'

Vue.config.productionTip = false
Vue.use(vueCustomElement)
Vue.use(LocalStorageWatcher)
Vue.filter('markdown', markdownFilter)

App.store = store

Vue.customElement('intelligential-widget', App)
